// extracted by mini-css-extract-plugin
export default {"lockedLink":"_frrzFAAdKkKWTlpbZMd","icon":"pnTorvhlhYbeA5fpEvWE","text":"Hk4_Gfi0XRU7F_tqHdhg"};